import React from 'react';
import Authorized from '@/components/Auth/auth';
export default function optLink(props) {
    const { allow, onClick = () => { }, lubanId, text, isLink = true, restProps = {} } = props;
    return isLink ? (<Authorized allow={allow}>
      <a onClick={onClick} luban-id={lubanId} {...restProps}>
        {text}
      </a>
    </Authorized>) : text;
}
// 通用操作
export let commonFun = {
    dispute: (onClick) => {
        return optLink({
            allow: 'psgjb-ordercontrasign-debate',
            onClick,
            lubanId: 'PSGJB-BID-CCGL-CCJJ',
            text: '争议',
        });
    },
    passIn: (onClick) => {
        return optLink({
            allow: 'psgjb-orderobili-fail',
            onClick,
            text: '流拍',
        });
    },
    viewContract: (onClick) => {
        return optLink({
            allow: 'psgjb-orderobili-review',
            onClick,
            text: '查看合同',
        });
    },
    applySellerCollection: (onClick) => {
        return optLink({
            allow: 'psgjb-orderobili-affirm',
            onClick,
            text: '申请向卖家付款',
        });
    },
    // 出价详情
    bidDetails: (onClick) => {
        return optLink({
            // allow: 'psgjb-auctionmanadone-edit',
            onClick,
            text: '出价详情',
        });
    },
};
// 中标车辆操作
export let winBiddingCar = {
    winningDeal: (onClick) => {
        return optLink({
            onClick,
            // lubanId: 'PSGJB-BID-CCGL-CCCK',
            text: '撮合成交',
        });
    },
    normalDeal: (onClick) => {
        return optLink({
            onClick,
            text: '正常成交',
        });
    },
    breakContract: (onClick) => {
        return optLink({
            // allow: 'psgjb-auctionmanadone-project',
            onClick,
            text: '违约',
        });
    },
};
// 待签署合同操作
export let waitSignContract = {
    signContract: (onClick) => {
        return optLink({
            allow: 'psgjb-ordercontrasign-sign',
            onClick,
            text: '成交合同签署',
        });
    },
    skipSignContract: (onClick) => {
        return optLink({
            allow: 'psgjb-ordercontrasign-skip',
            onClick,
            text: '跳过合同签署',
        });
    },
};
// 待付款车辆操作
export let waitPayCar = {
    applyFinancialCollection: (onClick) => {
        return optLink({
            allow: 'psgjb-orderobili-affirm',
            onClick,
            text: '申请财务收款',
        });
    },
};
// 交付中（原待过户）操作
export let waitTransferCar = {
    applySellerCollection: (onClick) => {
        return optLink({
            // allow: 'psgjb-auctionmanadone-edit',
            onClick,
            text: '申请向卖家付款',
        });
    },
    confirmLift: (onClick) => {
        return optLink({
            // allow: 'psgjb-auctionmanadone-delete',
            onClick,
            text: '确认提车',
        });
    },
    confirmTranfInfo: (onClick) => {
        return optLink({
            // allow: 'psgjb-auctionmanadone-delete',
            onClick,
            text: '确认过户信息',
        });
    },
    confirmDelivery: (onClick) => {
        return optLink({
            onClick,
            text: '确认交车',
        });
    },
    confirmTransfer: (onClick) => {
        return optLink({
            onClick,
            text: '确认过户',
        });
    },
};
export function optCollection(props) {
    const { pageIdentification, record, confirmTransferClick, confirmDeliveryClick, bidDetailsCilck, confirmTranfInfoClick, confirmLiftClick, applySellerCollectionClick, applyFinancialCollectionClick, viewContractClick, passInClick, disputeClick, signContractClick, skipSignContractClick, winningDealClick, normalDealClick, breakContractClick, } = props;
    switch (pageIdentification) {
        case 'winBiddingcar': // 中标车辆   撮合成交|正常成交|违约
            return (<>
          {winBiddingCar.winningDeal(winningDealClick)}
          {winBiddingCar.normalDeal(normalDealClick)}
          {winBiddingCar.breakContract(breakContractClick)}
          {commonFun.bidDetails(bidDetailsCilck)}
        </>);
        case 'waitSignContract': // 待买家签署合同   成交合同签署|争议|跳过合同签署
            return (<>
          {waitSignContract.signContract(signContractClick)}
          {commonFun.dispute(disputeClick)}
          {waitSignContract.skipSignContract(skipSignContractClick)}
          {commonFun.bidDetails(bidDetailsCilck)}
        </>);
        case 'waitPayCar': // 待付款车辆  争议|流拍|查看合同|申请财务收款
            return record.actionType === 10 && record.orderTag === 1 ?
                (<>
            {commonFun.dispute(disputeClick)}
            {commonFun.bidDetails(bidDetailsCilck)}
          </>) :
                (<>
            {waitPayCar.applyFinancialCollection(applyFinancialCollectionClick)}
            {commonFun.dispute(disputeClick)}
            {commonFun.passIn(passInClick)}
            {commonFun.viewContract(viewContractClick)}
            {commonFun.bidDetails(bidDetailsCilck)}
          </>);
        case 'waitTransfer': // 交付中车辆   确认交车|争议|流拍|查看合同|确认过户|确认过户信息|申请向卖家付款
            if (record.paymentNode === 1 && record.payStatus === 0 && (record.payApprovalStatus === 0 || record.payApprovalStatus === 3)) {
                if (record.actionType === 10 && record.orderTag === 1) { // 大域成交
                    switch (record.transferMode) {
                        case 0:
                            return (<>
                  {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                  {waitTransferCar.confirmTransfer(confirmTransferClick)}
                  {commonFun.dispute(disputeClick)}
                </>);
                        case 2:
                            switch (record.produceStatus) {
                                case 0:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 60:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {waitTransferCar.confirmDelivery(confirmDeliveryClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                        case 3:
                            switch (record.produceStatus) {
                                case 0:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 60:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {waitTransferCar.confirmLift(confirmLiftClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 70:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 80:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {waitTransferCar.confirmTranfInfo(confirmTranfInfoClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                    }
                }
                else {
                    switch (record.transferMode) {
                        case 0:
                            return (<>
                  {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                  {waitTransferCar.confirmTransfer(confirmTransferClick)}
                  {commonFun.dispute(disputeClick)}
                  {commonFun.passIn(passInClick)}
                  {commonFun.viewContract(viewContractClick)}
                  {commonFun.bidDetails(bidDetailsCilck)}
                </>);
                        case 2:
                            switch (record.produceStatus) {
                                case 0:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {waitTransferCar.confirmDelivery(confirmDeliveryClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                        case 3:
                            switch (record.produceStatus) {
                                case 0:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {waitTransferCar.confirmLift(confirmLiftClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 70:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 80:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {waitTransferCar.confirmTranfInfo(confirmTranfInfoClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                default:
                                    return (<>
                      {waitTransferCar.applySellerCollection(applySellerCollectionClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                    }
                }
            }
            else {
                if (record.actionType === 10 && record.orderTag === 1) { // 大域成交
                    switch (record.transferMode) {
                        case 0:
                            return (<>
                  {waitTransferCar.confirmTransfer(confirmTransferClick)}
                  {commonFun.dispute(disputeClick)}
                  {commonFun.bidDetails(bidDetailsCilck)}
                </>);
                        case 2:
                            switch (record.produceStatus) {
                                case 60:
                                    return (<>
                      {waitTransferCar.confirmDelivery(confirmDeliveryClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 0:
                                    return (<>
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                        case 3:
                            switch (record.produceStatus) {
                                case 60:
                                    return (<>
                      {waitTransferCar.confirmLift(confirmLiftClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 70:
                                    return (<>
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 80:
                                    return (<>
                      {waitTransferCar.confirmTranfInfo(confirmTranfInfoClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 0:
                                    return (<>
                      {commonFun.dispute(disputeClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                    }
                }
                else {
                    switch (record.transferMode) {
                        case 0:
                            return (<>
                  {waitTransferCar.confirmTransfer(confirmTransferClick)}
                  {commonFun.dispute(disputeClick)}
                  {commonFun.passIn(passInClick)}
                  {commonFun.viewContract(viewContractClick)}
                  {commonFun.bidDetails(bidDetailsCilck)}
                </>);
                        case 2:
                            switch (record.produceStatus) {
                                case 0:
                                    return (<>
                      {waitTransferCar.confirmDelivery(confirmDeliveryClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                        case 3:
                            switch (record.produceStatus) {
                                case 0:
                                    return (<>
                      {waitTransferCar.confirmLift(confirmLiftClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 80:
                                    return (<>
                      {waitTransferCar.confirmTranfInfo(confirmTranfInfoClick)}
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                                case 70:
                                    return (<>
                      {commonFun.dispute(disputeClick)}
                      {commonFun.passIn(passInClick)}
                      {commonFun.viewContract(viewContractClick)}
                      {commonFun.bidDetails(bidDetailsCilck)}
                    </>);
                            }
                        default:
                            return (<>
                  {commonFun.dispute(disputeClick)}
                  {commonFun.bidDetails(bidDetailsCilck)}
                </>);
                    }
                }
            }
    }
}
